import { isShellHost } from "../../utils/isShellHost";

export const pageNames = {
	ac: {
		home: "/minhas-dividas",
	},
	cp: {
		// TRANSITÓRIO até o rollout do shell: no shell unificado não existe
		// rota "/home" — brand CP compartilha as rotas do AC. Newco standalone
		// mantém "/home" até ser desligado; depois este getter vira
		// home: "/minhas-dividas" e isShellHost pode ser removido daqui.
		get home(): string {
			return isShellHost() ? pageNames.ac.home : "/home";
		},
	},
	signin: "/login",
	testeIframe: "/teste-iframe",
	signup: "/cadastro",
	signUpNCAD: "/negociacao-simplificada",
	signupNCADCompleted: "/cadastro-ncad-completo",
	signUpPartnerCompleted: "/cadastro-via-parceiro-completo",
	signupACPErrorKBA: "/cadastro/erro-informacoes",
	signupACPBlockedKBA: "/cadastro/falha-ao-validar-informacoes",
	recoveryPasswordACPInvalidKBA: "/recuperar-senha/erro-informacoes",
	recoveryPasswordACPBlockedKBA:
		"/recuperar-senha/falha-ao-validar-informacoes",
	resetPasswordACPInvalidKBA: "/redefinir-senha/erro-informacoes",
	resetPasswordACPBlockedKBA: "/redefinir-senha/falha-ao-validar-informacoes",
	signinACPFailedDocument: "/falha-ao-validar-documento",
	recoveryPassword: "/recuperar-senha",
	redefinePassword: "/redefinir-senha",
	redefinePasswordCP: "/criar-senha",
	redefinePasswordLink: "/redefinir-senha-link",
	newPassword: "/new-password",
	errorNoData: "/cadastro/erro-faltando-informacoes",
	errorKba: "/cadastro/erro-kba-limite",
	errorKbaBigDataCorp: "/cadastro/erro-kba-invalido",
	account: "/minha-conta",
	accountDeletion: "/minha-conta/deletar-conta",
	debts: "/dividas",
	myDebts: "/minhas-dividas",
	myOffers: "/minhas-ofertas",
	confirmation: "/:partner/confirmacao",
	agreementClosed: "/:partner/acordo-fechado",
	agreementClosedError: "/:partner/acordo-fechado/erro",
	billetNotFoundError: "/boleto-nao-encontrado",
	offers: "/ofertas",
	offerAnalysis: "/analisando-oferta",
	loans: "/emprestimos",
	myAgreements: "/meus-acordos",
	myAgreementsDetail: "/meus-acordos/acordo",
	negativeDebts: "/dividas-negativas",
	myScore: "/monitoramento/financeiro",
	scoreKbaQuestions: "/monitoramento/score",
	scoreError: "/monitoramento/erro",
	accountCanceled: "/conta-cancelada",
	contactUs: "/fale-conosco",
	updateEmail: "/atualizar-email",
	updateEmailACP: "/atualizar-contato/email",
	updatePhoneACP: "/atualizar-contato/telefone",
	updateSocialNameACP: "/atualizar-nome-social",
	updatePasswordACP: "/alterar-senha",
	validateConflictingEmailACP: "/validar-contato/email",
	publicEmailConfirmation: "/confirmacao-de-email",
	signinUnifyPasswordACP: "/unificar-senha",
	updateContactSuccess: "/atualizar-contato/sucesso",
	updatePasswordSuccess: "/alterar-senha/sucesso",
	unlockProtectedFeature: "/validar-identidade",
	unlockProtectedFeatureSuccess: "/validar-identidade/sucesso",
	unlockProtectedFeaturePassword: "/validar-identidade/recuperar-senha",
	notFound: "/pagina-nao-encontrada",
};
